var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSwitchIcon = function SvgSwitchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 10a8 8 0 1 0-16 0 8 8 0 0 0 16 0ZM5.636 4.91c.402 0 .728.325.728.726v.801A5.076 5.076 0 0 1 10 4.91c1.698 0 3.203.833 4.126 2.109a.727.727 0 1 1-1.178.853A3.63 3.63 0 0 0 10 6.364a3.63 3.63 0 0 0-2.91 1.454h1.455a.727.727 0 1 1 0 1.455H5.636a.727.727 0 0 1-.727-.728V5.636c0-.401.326-.727.727-.727Zm8 8.653A5.076 5.076 0 0 1 10 15.09a5.082 5.082 0 0 1-3.891-1.808.727.727 0 1 1 1.111-.939A3.627 3.627 0 0 0 10 13.636a3.63 3.63 0 0 0 2.91-1.454h-1.456a.727.727 0 0 1 0-1.455h2.91c.401 0 .727.326.727.727v2.91a.727.727 0 1 1-1.455 0v-.801Z",
    fill: "#666"
  })));
};
export default SvgSwitchIcon;